import { z } from 'zod';

/** Input-only required text which validates trimmed content without transforming it. */
export function requiredClientText(maxLength: number) {
  return z
    .string()
    .max(maxLength)
    .refine((value) => value.trim().length > 0, {
      message: 'Required text must not be blank',
    });
}
